var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRefresh = function SvgRefresh(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 18",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.672 3.328 16.016.984v7.032H8.984L12.22 4.78Q10.437 3.001 8 3 5.516 3 3.734 4.781 2 6.516 2 9t1.734 4.266Q5.516 15 8 15q1.734 0 3.375-1.172 1.687-1.172 2.297-2.812h2.062q-.656 2.625-2.812 4.312T8 17.016q-3.28 0-5.625-2.344Q.032 12.328.031 9q0-3.329 2.344-5.672Q4.72.985 8 .984q1.406 0 3.047.704 1.688.656 2.625 1.64"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };